import React, { Suspense } from "react";
import Spinner from "./spinner";

export const LazySuspense: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <Suspense fallback={<Spinner />}>{children}</Suspense>;
